import { render, staticRenderFns } from "./WorkDetailComponents.vue?vue&type=template&id=c14185be&scoped=true&"
import script from "./WorkDetailComponents.vue?vue&type=script&lang=js&"
export * from "./WorkDetailComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14185be",
  null
  
)

export default component.exports